<template>
    <div>
        <t-loader :loading="isBusy"></t-loader>
        <div class="card">
            <div class="card-header">
                <div role="group" class="form-row form-group mb-2 justify-content-between">
                    <div>
                        All users <br>
                        <small>Registered user</small>
                    </div>

                    <div class="col-xs filter">
                        <b-input-group size="sm">
                            <b-form-input
                                id="filter-input"
                                v-model="filter"
                                type="search"
                                placeholder="Search"
                                debounce="500"
                            ></b-form-input>
                            <b-input-group-append>
                                <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                            </b-input-group-append>
                        </b-input-group>
                    </div>
                </div>
            </div>
            <div class="card-body">
                <b-table
                    show-empty
                    :responsive="true"
                    :items="userProvider"
                    :busy.sync="isBusy"
                    :fields="fields"
                    :current-page="currentPage"
                    :per-page="perPage"
                    ref="table"
                    :filter="filter"
                    class="table hover table-striped"
                >

                    <template v-slot:cell(status)="data">
                        <template v-if="data.item.active">
                            <ion-icon name="checkmark" class="text-success icon-fit"
                                      v-if="data.item.status === 'approved'"></ion-icon>
                            <ion-icon name="close" class="text-danger icon-fit"
                                      v-if="data.item.status === 'rejected'"></ion-icon>
                            <ion-icon name="hourglass" class="text-info icon-fit"
                                      v-if="data.item.status === 'pending'"></ion-icon>
                            <span class="text-capitalize" :class="textStatusClass(data.item.status)">{{ data.item.status }}</span>

                        </template>
                        <template v-else>
                            <ion-icon name="close" class="text-warning icon-fit"></ion-icon>
                            <span class="text-warning" :title="suspendedTitle(data.item.status)">Suspended</span>
                        </template>
                    </template>

                    <template v-slot:cell(nationality)="data">
                        <span class="mr-2 flag-icon" :class="flag(data.item.nationality)"></span>
                        {{data.item.nationality}}
                    </template>

                    <template v-slot:cell(eid)="data">
                        <span v-if="data.item.eid">
                            <div class="d-flex justify-content-between">
                                <strong>{{data.item.eid}}</strong>
                                <span style="font-family: monospace;">{{data.item.personalNumber}}</span>
                            </div>
                        </span>
                    </template>

                    <template v-slot:cell(transactions)="data">
                        <span title="Handled / Pending">
                            {{data.item.handledTransactions}} / {{data.item.notHandledTransactions}}
                        </span>
                    </template>

                    <template v-slot:cell(action)="data">
                        <a v-if="data.item.url" class="" :href="data.item.url">View</a>
                    </template>
                </b-table>
                <b-pagination
                    v-model="currentPage"
                    :total-rows="totalRows"
                    :per-page="perPage"
                    aria-controls="user-table"
                ></b-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    name: 'UserList',
    props: {
        url: String,
    },
    data() {
        return {
            totalRows: 1,
            currentPage: 1,
            perPage: 20,
            users: [],
            isBusy: false,
            filter: '',
            defaultFields: [
                {key: 'id', label: '#'},
                {key: 'name', label: 'Talent'},
                {key: 'status', label: 'Status'},
                {key: 'referralCode', label: 'Referral'},
                {key: 'roles', label: 'Roles'},
                {key: 'transactions', label: 'Transactions'},
                {key: 'invoiceCount', label: 'Invoices'},
                {key: 'nationality', label: 'Nationality'},
                {key: 'eid', label: 'EID (Electronic ID'},
                {key: 'created_at', label: 'Joined at'},
                {key: 'action', label: 'Action'},
            ],
        };
    },
    computed: {
        fields() {
            return this.defaultFields;
        },
    },
    watch: {
        filter(newFilter, oldFilter) {
            if (newFilter !== oldFilter) {
                // Current page is invalid when filter is applied
                this.currentPage = 1
            }
        }
    },
    methods: {
        roleClass(value) {
            return `user-role-badge-${value}`;
        },
        statusClass(value) {
            if (value === 'approved') {
                return 'success';
            }
            if (value === 'pending') {
                return 'info';
            }
            return `danger`;
        },
        textStatusClass(value){
          return `text-${this.statusClass(value)}`;
        },
        suspendedTitle(value){
          return `previous status: ${value}`;
        },
        flag(value){
          return `flag-icon-${value.toLowerCase()}`
        },
        noScheme(url) {
            return url.replace(/^https?:/, '');
        },
        userProvider(ctx) {
            let url = this.noScheme(this.url);
            url += `?page=${ctx.currentPage}&size=${ctx.perPage}&filter=${ctx.filter}`;
            const promise = axios.get(url);

            return promise.then(response => {
                const data = response.data.data;
                const meta = response.data.meta;
                this.currentPage = meta.current_page;
                this.totalRows = meta.total;
                this.users = data || [];

                console.log(this.users);

                return this.users;
            }).catch(error => {
                // console.log(error);

                return [];
            });
        },
        refresh() {
            this.$nextTick(() => {
                this.$refs.table.refresh();
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.filter {
    min-width: 420px;
}

input#filter-input {
    height: 35px;
    padding-left: 10px;
    border: solid rgba(68, 68, 94, 0.36);
    border-width: 0 0 0.5px 0.5px;
    border-radius: 0;

    &:focus {
        border-bottom: 2px solid #ff990d;
    }
}

.input-group-append {
    margin-left: 0;
}

div.input-group-append button.btn.btn-secondary {
    border-radius: 0;
}
</style>
